import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';
import { IconUserUp } from '@tabler/icons-react';
import { cn } from '../../../lib/utils';
import userAndOrganizationActivityAnalyticService from '../../../services/user-and-organization-activity-analytics.service';

const InvitedUsersStats = () => {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await userAndOrganizationActivityAnalyticService.getInvitedUserStats();
        setStatsData(data);
      } catch (err) {
        console.error('Error fetching stats:', err);
        setError('Failed to load statistics.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (error) {
    return (
      <div className="text-red-600">{error}</div>
    );
  }

  const activationRate = statsData?.activation_stats?.percentage ?? '-';
  const firstLoginRate = statsData?.login_stats?.percentage ?? '-';

  return (
    <Card className="shadow-sm border-0">
      <CardContent className="pt-6">
        <div className="flex justify-between items-center mb-3">
          <div
            className={cn(
              'p-2 rounded',
              loading ? 'bg-gray-100' : 'bg-blue-500 text-white'
            )}
            style={{ width: 40, height: 40 }}
          >
            <IconUserUp size={24} />
          </div>

          {loading && <Skeleton className="w-[60px] h-5" />}
        </div>

        <div>
          <h5 className="text-lg font-bold mb-2">Invited Users Metrics</h5>

          <div className="flex justify-between">
            <div>
              <p className="text-muted-foreground text-sm mb-1">Activation Rate</p>
              <h5 className="text-xl font-semibold">
                {loading ? (
                  <Skeleton className="w-[60px] h-6" />
                ) : (
                  `${activationRate}%`
                )}
              </h5>
            </div>

            <div>
              <p className="text-muted-foreground text-sm mb-1">First Login Rate</p>
              <h5 className="text-xl font-semibold">
                {loading ? (
                  <Skeleton className="w-[60px] h-6" />
                ) : (
                  `${firstLoginRate}%`
                )}
              </h5>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InvitedUsersStats;
